import React from 'react';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { getProgramById } from '../../data/programs';
export function CompetitionTeamPage() {
  const program = getProgramById('competition-team');
  if (!program) {
    return null;
  }
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-872">
      <Header data-id="element-873" />

      <main className="pt-20" data-id="element-874">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-slate-900 to-slate-800 text-white py-20" data-id="element-875">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-876">
            <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-877">
              {program.name}
            </h1>
            <p className="text-lg text-slate-200 max-w-2xl" data-id="element-878">
              {program.description}
            </p>
          </div>
        </section>

        {/* Placeholder Content */}
        <section className="py-16 bg-white" data-id="element-879">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-880">
            <div className="aspect-video rounded-xl overflow-hidden mb-8" data-id="element-881">
              <img src={program.image} alt={program.name} className="w-full h-full object-cover" data-id="element-882" />
            </div>

            <div className="prose max-w-none" data-id="element-883">
              <h2 className="text-3xl font-bold text-[#1a2332] mb-4" data-id="element-884">
                Program Details Coming Soon
              </h2>
              <p className="text-slate-600" data-id="element-885">
                Detailed information about our {program.name} program will be
                added here soon. Please contact us for more information about
                this program.
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-886" />
    </div>;
}